//MANAGER PERSONAL INFO
export const MANAGER_PERSONAL_INFO_REQUEST = 'MANAGER_PERSONAL_INFO_REQUEST';
export const MANAGER_PERSONAL_INFO_SUCCESS = 'MANAGER_PERSONAL_INFO_SUCCESS';
export const MANAGER_PERSONAL_INFO_FAIL = 'MANAGER_PERSONAL_INFO_FAIL';

//GET MANAGER PERSONAL INFO
export const GET_MANAGER_PERSONAL_INFO_REQUEST =
  'GET_MANAGER_PERSONAL_INFO_REQUEST';
export const GET_MANAGER_PERSONAL_INFO_SUCCESS =
  'GET_MANAGER_PERSONAL_INFO_SUCCESS';
export const GET_MANAGER_PERSONAL_INFO_FAIL = 'GET_USER_PERSONAL_INFO_FAIL';
